import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Formik, Form, Field } from 'formik';
import Swal from "sweetalert2";
import UserBankAcountModel from "../../models/UserBankAcountModel";
import { RiRefreshLine, RiVipCrown2Fill } from "react-icons/ri";

function ModalRenewAccount(props) {
    const bankData = props.data || {};
    const bankNumber = bankData.bank_number || bankData.account_number || '';
    const bankName = props.bankName || bankData.bank_name || bankData.name || '';
    const accountId = bankData.id || props.user_bank_account_id || props.id;
    const isFromCombo = bankData.is_from_combo == 1;

    const rawComboDays = props.userData
        ? (Number(props.userData.combo_days || 0) > 0
            ? Number(props.userData.combo_days)
            : Number(props.userData.combo_slots || 0) * 30)
        : 0;
    const comboSlots = Math.floor(rawComboDays / 30);
    const hasComboDays = rawComboDays > 0;
    const canUseCombo = rawComboDays >= 9;

    const defaultRegisterTime =
        rawComboDays >= 30
            ? 'combo_month'
            : rawComboDays >= 17
            ? 'combo_half_month'
            : rawComboDays >= 9
            ? 'combo_week'
            : 'month';

    const [initialValues, setInitialValues] = useState({
        id: accountId,
        accountNumber: bankNumber,
        isPriority: props.isPriority || bankData.is_priority || 0,
        bank_name: bankName,
        registerTime: defaultRegisterTime,
        use_combo: canUseCombo ? 1 : 0
    });
    
    useEffect(() => {
        const initTime =
            rawComboDays >= 30
                ? 'combo_month'
                : rawComboDays >= 17
                ? 'combo_half_month'
                : rawComboDays >= 9
                ? 'combo_week'
                : 'month';
        setInitialValues({
            id: bankData.id || props.user_bank_account_id || props.id,
            accountNumber: bankData.bank_number || bankData.account_number || '',
            isPriority: props.isPriority || bankData.is_priority || 0,
            bank_name: props.bankName || bankData.bank_name || bankData.name || '',
            registerTime: initTime,
            use_combo: canUseCombo ? 1 : 0
        });
    }, [props.data, props.bankName, props.id, props.user_bank_account_id, props.isPriority, isFromCombo, rawComboDays, canUseCombo]);

    const onSubmit = (values) => {
        const payload = { ...values };
        if (['combo', 'combo_month', 'combo_half_month', 'combo_week'].includes(payload.registerTime)) {
            payload.use_combo = 1;
        } else {
            payload.use_combo = 0;
            payload.use_normal_balance = 1;
        }

        UserBankAcountModel.renewAccount(payload).then((res) => {
            if (res.success === true || res.success === "true") {
                Swal.fire({
                    icon: "success",
                    title: res.message || res.data || "Gia hạn tài khoản thành công!",
                    showConfirmButton: true,
                    timer: 2000
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: res.data || res.message || "Gia hạn tài khoản thất bại!",
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            props.onHide();
            setTimeout(() => {
                if (typeof props.reloadPage === 'function') {
                    props.reloadPage(props.id, props.type);
                }
            }, 1500);
        }).catch((err) => {
            Swal.fire({
                icon: "error",
                title: err?.response?.data?.message || err?.response?.data?.data || "Gia hạn tài khoản thất bại!",
                showConfirmButton: false,
                timer: 2000
            });
        });
    };

    const getRegisterFee = (time) => {
        switch (time) {
            case "combo":
            case "combo_month": return "0 VNĐ (Trừ 30 ngày VIP • Không phí)";
            case "combo_half_month": return "0 VNĐ (Trừ 17 ngày VIP • Phí: 2 ngày)";
            case "combo_week": return "0 VNĐ (Trừ 9 ngày VIP • Phí: 2 ngày)";
            case "week": return "1.300.000 VNĐ";
            case "month": return "2.500.000 VNĐ";
            case "quarter": return "5.000.000 VNĐ";
            case "forever": return "10.000.000 VNĐ";
            default: return "0 VNĐ";
        }
    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="d-flex align-items-center gap-2">
                    <RiRefreshLine size={18} style={{ color: 'var(--wus-text)' }} />
                    <span>Gia Hạn Tài Khoản Ngân Hàng</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    onSubmit={onSubmit}
                >
                    {({ values }) => {
                        const isVipTime = ['combo', 'combo_month', 'combo_half_month', 'combo_week'].includes(values.registerTime);
                        return (
                        <Form>
                            <div className="wus-info-box mb-3">
                                <div className="d-flex justify-content-between align-items-center py-2 px-1" style={{ borderBottom: '1px solid var(--wus-border)' }}>
                                    <span style={{ color: 'var(--wus-text-muted)', fontSize: '13px' }}>Ngân hàng:</span>
                                    <div className="d-flex align-items-center gap-1">
                                        <span style={{ color: 'var(--wus-text)', fontWeight: '600', fontSize: '13.5px' }}>{bankName || '---'}</span>
                                        {isFromCombo && (
                                            <span className="badge-combo-vip">
                                                <RiVipCrown2Fill size={10} /> VIP
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2 px-1">
                                    <span style={{ color: 'var(--wus-text-muted)', fontSize: '13px' }}>Số tài khoản:</span>
                                    <span style={{ color: 'var(--wus-text)', fontWeight: '700', fontSize: '14px', fontFamily: 'var(--wus-mono)' }}>{bankNumber || '---'}</span>
                                </div>
                            </div>

                            {/* Combo VIP notices */}
                            {hasComboDays ? (
                                <div className="d-flex align-items-start gap-2 p-3 mb-3" style={{ background: 'var(--wus-warning-bg)', border: '1px solid var(--wus-warning-border)', borderRadius: '10px', color: 'var(--wus-text)', fontSize: '13px' }}>
                                    <RiVipCrown2Fill size={22} style={{ color: 'var(--wus-warning-text)', marginTop: '2px' }} className="flex-shrink-0" />
                                    <div>
                                        <strong style={{ color: 'var(--wus-warning-text)' }}>
                                            QUỸ NGÀY VIP: {rawComboDays} NGÀY (~{comboSlots} LƯỢT{rawComboDays % 30 > 0 ? ` + ${rawComboDays % 30} NGÀY LẺ` : ''})
                                        </strong>
                                        <div style={{ color: 'var(--wus-text-secondary)', fontSize: '12px', marginTop: '3px', lineHeight: '1.45' }}>
                                            Hỗ trợ gia hạn VIP theo <strong>1 Tháng (30 ngày VIP)</strong>, <strong>Nửa Tháng (17 ngày VIP • Phí: 2 ngày)</strong> hoặc <strong>1 Tuần (9 ngày VIP • Phí: 2 ngày)</strong>.
                                        </div>
                                    </div>
                                </div>
                            ) : isFromCombo ? (
                                <div className="p-3 mb-3" style={{ background: 'var(--wus-danger-bg)', border: '1px solid var(--wus-danger-border)', borderRadius: '10px', color: 'var(--wus-danger-text)', fontSize: '12.5px' }}>
                                    ⚠️ <strong>Hết ngày Combo VIP:</strong> Quỹ ngày VIP của bạn đã hết. Tài khoản này chuyển sang biểu phí gia hạn thông thường.
                                </div>
                            ) : null}

                            <div className="mb-3">
                                <label htmlFor="registerTime" className="form-label">
                                    Chọn thời gian gia hạn:
                                </label>
                                <Field
                                    as="select"
                                    id="registerTime"
                                    name="registerTime"
                                    className="form-control"
                                >
                                    {rawComboDays >= 30 && (
                                        <option value="combo_month">👑 Gia hạn VIP 1 Tháng (30 ngày) — Trừ 30 ngày VIP (0 VNĐ)</option>
                                    )}
                                    {rawComboDays >= 17 && (
                                        <option value="combo_half_month">👑 Gia hạn VIP Nửa Tháng (15 ngày) — Trừ 17 ngày VIP (Phí: 2 ngày • 0 VNĐ)</option>
                                    )}
                                    {rawComboDays >= 9 && (
                                        <option value="combo_week">👑 Gia hạn VIP 1 Tuần (7 ngày) — Trừ 9 ngày VIP (Phí: 2 ngày • 0 VNĐ)</option>
                                    )}
                                    <option value="week">Gói Thường 1 Tuần (1.300.000 VNĐ)</option>
                                    <option value="month">Gói Thường 1 Tháng (2.500.000 VNĐ)</option>
                                </Field>
                            </div>

                            <div className="d-flex align-items-center justify-content-between p-3 mb-3 wus-summary-box">
                                <span style={{ color: 'var(--wus-text-muted)', fontSize: '13px' }}>Phí gia hạn:</span>
                                <span style={{ color: isVipTime ? 'var(--wus-warning-text)' : 'var(--wus-text)', fontSize: '14px', fontWeight: '700', fontFamily: 'var(--wus-mono)' }}>
                                    {getRegisterFee(values.registerTime)}
                                </span>
                            </div>

                            <div className="d-flex justify-content-end gap-2 pt-3" style={{ borderTop: '1px solid var(--wus-border)' }}>
                                <button type="button" className="btn btn-secondary" onClick={props.onHide}>
                                    Hủy bỏ
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    {isVipTime ? 'Xác nhận gia hạn VIP' : 'Xác nhận gia hạn'}
                                </button>
                            </div>
                        </Form>
                    )}}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}

export default ModalRenewAccount;
